<template>
    <div class="form-group">
        <el-checkbox-group v-model="conformity">
            <div class="form-group">
                <el-checkbox label="strictMode">{{
                    $l10n.__(
                        'Bloquer la modification, la suppression ou l‘annulation d‘une facture ou d‘un avoir finalisé',
                    )
                }}</el-checkbox>
            </div>

            <div class="form-group">
                <el-checkbox label="forbidEditIdent">{{
                    $l10n.__('Bloquer la modification du numéro des factures et des avoirs')
                }}</el-checkbox>
            </div>

            <div class="form-group">
                <CompassTooltip :disabled="!isDisabled('forbidEditDate')">
                    <template #content><span>{{
                            $l10n.__(
                                'Vous ne pouvez pas bloquer la modification de la date car un ou plusieurs documents (factures ou avoirs) possèdent une date dans le futur.',
                            )
                        }}</span></template
                    >
                    <el-checkbox label="forbidEditDate" :disabled="isDisabled('forbidEditDate')">{{
                        $l10n.__('Bloquer la modification de la date des factures et des avoirs')
                    }}</el-checkbox>
                </CompassTooltip>
            </div>
        </el-checkbox-group>

        <div class="mt-3">
            <CompassButton :label="$t.__('common.actions.save')" @click.prevent="save" />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        defaultConformity: {
            type: Array,
            required: true,
        },
        disabledConformity: {
            type: Array,
            required: true,
        },
    },
    data: function () {
        return {
            conformity: this.defaultConformity,
        };
    },
    methods: {
        save: function () {
            const options = {
                conformity: this.conformity,
            };

            this.$ajax.put(
                `/rest/documents/conformity-preferences`,
                {},
                options,
                (data) => {
                    Push.success(this.$l10n.__('Préférences enregistrées'));
                },
                (error) => {
                    Push.error(error.response.data.error.message);
                },
            );
        },

        isDisabled: function (conformity) {
            return this.disabledConformity.includes(conformity);
        },
    },
};
</script>
